import logoAsset from "@/assets/logo.png.asset.json";

const Footer = () => (
  <footer className="bg-card border-t border-border py-12">
    <div className="container mx-auto px-4 text-center">
      <img src={logoAsset.url} alt="Silver Sage Homeschool Hub logo" width={60} height={60} className="mx-auto mb-4" loading="lazy" />
      <p className="font-heading text-lg text-foreground mb-1">Silver Sage Homeschool Hub</p>
      <p className="text-sm text-muted-foreground italic mb-4">Empowering Homeschool Journeys</p>
      <p className="text-sm text-muted-foreground mb-4">
        Contact us: <a href="mailto:silversagehomeschoolhubs@gmail.com" className="text-primary hover:underline">silversagehomeschoolhubs@gmail.com</a>
      </p>
      <p className="text-xs text-muted-foreground">© 2024 Silver Sage Homeschool Hub. All rights reserved.</p>
    </div>
  </footer>
);

export default Footer;
